import { Link } from "react-router-dom";
import { useReveal } from "@/hooks/useReveal";
import { LOGO_URL } from "@/lib/data";

export const Hero = () => {
  const ref1 = useReveal();
  const ref2 = useReveal();
  const ref3 = useReveal();

  return (
    <section id="top" className="relative pt-28 pb-20 lg:pt-32 lg:pb-24 overflow-hidden">
      <div className="glow-blob bg-[hsl(var(--accent))] -top-32 -left-32 w-[420px] h-[420px]" style={{ opacity: 0.25 }} />
      <div className="glow-blob bg-[hsl(var(--accent))] top-1/3 -right-32 w-[520px] h-[520px]" style={{ opacity: 0.18 }} />

      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-10">
        <div ref={ref1} className="reveal flex items-center gap-3 mb-8">
          <span className="pulse-dot inline-block h-2.5 w-2.5 rounded-full bg-[hsl(var(--accent))]" />
          <span className="text-xs uppercase tracking-[0.22em] text-white/70 font-medium">
            Marketing Bureau
          </span>
        </div>

        <h1
          ref={ref2}
          data-testid="hero-headline"
          className="reveal font-display text-[32px] sm:text-5xl lg:text-[60px] leading-[1.05] font-bold tracking-tight max-w-4xl"
        >
          Vi gør dit brand{" "}
          <span className="relative inline-block">
            <span className="relative z-10 text-[hsl(var(--accent))]">umulig</span>
            <span className="absolute inset-x-0 bottom-2 h-3 bg-[hsl(var(--accent))]/15 -z-0 rounded-md" />
          </span>{" "}
          at ignorere.
        </h1>

        <div ref={ref3} className="reveal mt-10 grid lg:grid-cols-12 gap-10 items-end">
          <p className="lg:col-span-7 text-base sm:text-lg text-white/70 leading-relaxed max-w-2xl">
            Vi skaber content der stopper scroll, annoncer der konverterer og brands der bliver husket.
          </p>

          <div className="lg:col-span-5 flex flex-col sm:flex-row gap-3">
            <Link
              to="/kontakt"
              data-testid="hero-primary-cta"
              className="btn-pop inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-[hsl(var(--accent))] text-[hsl(var(--accent-ink))] font-semibold hover:shadow-[0_12px_40px_-8px_hsla(75,100%,67%,0.7)]"
            >
              Få en gratis analyse
              <span aria-hidden>→</span>
            </Link>
            <Link
              to="/cases"
              data-testid="hero-secondary-cta"
              className="btn-pop inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-white/15 text-white/90 hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))]"
            >
              Se vores cases
            </Link>
          </div>
        </div>

        <div className="mt-16 flex justify-center lg:justify-start">
          <div className="relative rounded-3xl p-1 bg-gradient-to-br from-[hsl(var(--accent))]/40 via-white/5 to-transparent max-w-md w-full">
            <div className="rounded-3xl bg-[hsl(var(--bg-card))] p-6 sm:p-8 flex items-center gap-5">
              <div className="h-20 w-20 sm:h-24 sm:w-24 rounded-2xl overflow-hidden ring-2 ring-[hsl(var(--accent))]/50 flex-shrink-0">
                <img src={LOGO_URL} alt="LD Media" className="h-full w-full object-cover" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-widest text-[hsl(var(--accent))] font-semibold">
                  LD Media
                </div>
                <div className="font-display text-2xl font-bold mt-1">Vækst gennem creative</div>
                <div className="text-sm text-white/60 mt-1">Bureau med fokus på resultater for dig.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
